import api from "@/api";
import restfulApi from "@/api/restfulApi";

export default {

  /**
   * возвращает варианты адресов + их сигнатуры
   * @param addressPart
   * @returns Promise
   */
  getAddressVariants(addressPart) {
    return api.get(restfulApi.getLink('proxy_ahunter_suggest', 'GET'), {params: {query: addressPart}})
      .then(response => response.data)
      .catch(e => Promise.reject(e))
  },

  /**
   * возвращает данные о доме по сигнатуре
   * ПЛАТНАЯ API, ДЕРГАТЬ ТОЛЬКО ПО НЕОБХОДИМОСТИ
   * @param addressSign String
   * @returns Promise
   */
  getHouseInfo(addressSign) {
    return api.get(restfulApi.getLink('proxy_ahunter_info', 'GET'), {params: {query: addressSign}})
      .then(response => response.data)

  },

  /**
   * проверка, содержит ли адрес номер дома
   * @param addressSign String
   * @returns {Promise<boolean>}
   */
  hasHouseInAddress(addressSign) {
    return api.get(restfulApi.getLink('proxy_ahunter_is_house', 'GET'), {params: {query: addressSign}})
      .then(response => Boolean(response.data.address.fields.find(i => i.level === 'House').name))
      .catch(e => Promise.reject(e))
  }
}
